'use strict';

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = _assign2.default || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _makeDefaultKeyFunction = require('./makeDefaultKeyFunction');

var _makeDefaultKeyFunction2 = _interopRequireDefault(_makeDefaultKeyFunction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var typeCreator = function typeCreator(prefix) {
  return {
    resetAction: function resetAction() {
      var payload = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
      return _extends({ type: prefix + '_RESET' }, payload);
    },
    requestAction: function requestAction() {
      var payload = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
      return _extends({ type: prefix + '_LOAD' }, payload);
    },
    successAction: function successAction() {
      var payload = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
      return _extends({ type: prefix + '_SUCCESS' }, payload);
    },
    errorAction: function errorAction() {
      var payload = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
      return _extends({ type: prefix + '_ERROR' }, payload);
    },
    types: [prefix + '_RESET', prefix + '_LOAD', prefix + '_SUCCESS', prefix + '_ERROR']
  };
};

var selectKeys = function selectKeys(state) {
  return (0, _keys2.default)(state.loading).filter(function (key) {
    return key !== 'lastKey';
  });
};
var selectData = function selectData(state, key) {
  return state.data[key || 'default'] || null;
};
var selectError = function selectError(state, key) {
  return state.error[key || 'default'] || null;
};
var selectLoading = function selectLoading(state, key) {
  return state.loading[key || 'default'] || false;
};
var selectLoaded = function selectLoaded(state, key) {
  return state.loaded[key || 'default'] || false;
};

var selectAsyncAttributes = function selectAsyncAttributes() {
  return {
    data: selectData.apply(undefined, arguments),
    error: selectError.apply(undefined, arguments),
    loading: selectLoading.apply(undefined, arguments),
    loaded: selectLoaded.apply(undefined, arguments)
  };
};

exports.default = function (name, promise) {
  var extras = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
  return _extends({
    name: name,
    promise: promise,
    transformData: function transformData(data) {
      return data;
    }
  }, extras, { defaultKey: (0, _makeDefaultKeyFunction2.default)(extras.defaultKey) }, typeCreator(name), {
    keys: function keys(selector, state) {
      return selectKeys(selector(state));
    },
    data: function data(selector, state, key) {
      return selectData(selector(state), key);
    },
    error: function error(selector, state, key) {
      return selectError(selector(state), key);
    },
    loaded: function loaded(selector, state, key) {
      return selectLoaded(selector(state), key);
    },
    loading: function loading(selector, state, key) {
      return selectLoading(selector(state), key);
    },
    select: function select(selector, state, key) {
      return selectAsyncAttributes(selector(state), key);
    },
    lastLoadedKey: function lastLoadedKey(selector, state) {
      return selector(state).loaded.lastKey;
    },
    lastRequestedKey: function lastRequestedKey(selector, state) {
      return selector(state).loading.lastKey;
    }
  });
};